export default class NavigationService {
  static getLanguage(locale: string): string {
    return locale.split('-')[0];
  }
}
